import * as R from 'ramda'
import moment from 'moment'
import { parsePeriod } from 'utils/stuff'

export default (properties, startMarketDateByPropertyID, period) => {
	let parsedPeriod = period == 'projected' ? parsePeriod(moment().year()): parsePeriod(period)

	let res = R.map(property => {
		let startPeriod = moment(parsedPeriod.from) > moment(startMarketDateByPropertyID[property._id]) ? parsedPeriod.from : startMarketDateByPropertyID[property._id]
		let days = moment(parsedPeriod.to).diff(moment(startPeriod), 'days')
		return (+property.priceDwellings || 0) / 27.5 / 365 * days
	})(properties)

	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0))(res)

	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/depreciation.js